import React from 'react';
import Modal from 'react-modal';
import moment from 'moment';
import { TRIAL_DAYS } from '../../variables/variables';
import { getNumberAsString } from '../../common/QuestionAnswerHelpers';
import { cancelDeleteButtonStyles, deleteButtonStyles } from '../../common/AtomStyles';
import { deleteModalStyles } from '../../common/ModalStyles';
import { applicationVariables, trialVariables } from '../../variables/variables';
import { FaTimesCircle } from 'react-icons/fa';

export function TrialModal({
  isOpen,
  onConfirm,
  onCancel,
  trialStarted,
}) {
  function calculateDaysRemaining() {
    if (!trialStarted) {
      return trialVariables.labelWelcome;
    }
    const difference = new Date().getTime() - trialStarted.getTime();
    const daysRemaining = TRIAL_DAYS - Math.round(difference / 86400000); // Seconds in a day
    if (daysRemaining < 0) {
      return trialVariables.labelTrialExpired;
    }
    if (daysRemaining <= 1) {
      return trialVariables.labelLastDay;
    }
    if (daysRemaining === TRIAL_DAYS) {
      return trialVariables.labelFirstDay;
    }
    const daysVerbose = getNumberAsString(daysRemaining, 13);
    return trialVariables.labelDaysRemaining1 + daysVerbose + trialVariables.labelDaysRemaining2;
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      ariaHideApp={false}
      style={deleteModalStyles}
    >
      <h3>{calculateDaysRemaining()}</h3>
      <div>
        <div>
          <p>{trialVariables.labelTrialStarted} {moment(trialStarted).format("Do MMMM YYYY")}.</p>
          <p>
            {trialVariables.labelGetInContact} &nbsp;
            <a href="{applicationVariables.contactUrl}" target="_blank" rel="noreferrer">
              {applicationVariables.serviceName}
            </a>.
          </p>
        </div>
        <button onClick={onConfirm} style={deleteButtonStyles}>
          {trialVariables.labelClose}
        </button>
      </div>
      <button onClick={onCancel} style={{width: '2rem', cursor: 'pointer', ...cancelDeleteButtonStyles}}>
        <FaTimesCircle style={{height: '100%', width: '100%'}}/>
      </button>
    </Modal>
  );
}
